<div class="flex flex-col gap-4"><slot /></div>
